export const MissclickIcon = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3957_4942)">
      <path
        d="M9.51367 1.67725C13.6963 1.88904 17.0634 5.18522 17.3906 9.33643L15.6494 8.83838C15.0995 5.71053 12.3705 3.3335 9.08496 3.3335C5.40397 3.33438 2.41921 6.31838 2.41895 9.99951C2.41895 13.6809 5.40381 16.6656 9.08496 16.6665C10.998 16.6665 12.7217 15.8586 13.9375 14.5679L14.7793 16.0815C13.2892 17.477 11.2873 18.3335 9.08496 18.3335L8.65625 18.3228C4.39575 18.106 0.978445 14.689 0.762695 10.4282L0.751953 9.99951C0.752217 5.39791 4.4835 1.66738 9.08496 1.6665L9.51367 1.67725ZM14.207 10.3394L20.7988 11.6187C21.3053 11.7172 21.4144 12.3936 20.9648 12.647L19.166 13.6606C19.0034 13.7523 18.8976 13.9207 18.8848 14.1069L18.7061 16.687C18.6697 17.2079 17.9997 17.3944 17.6992 16.9673L13.6484 11.2026C13.3614 10.7942 13.7171 10.2447 14.207 10.3394ZM11.4121 6.86279C11.734 6.59067 12.2162 6.6012 12.5264 6.8999C12.8361 7.19906 12.8641 7.68164 12.6035 8.01318L12.5469 8.07568L10.4922 10.2085L12.626 12.2642L12.6846 12.3267C12.9564 12.6486 12.9461 13.1309 12.6475 13.4409C12.3486 13.7508 11.8669 13.779 11.5352 13.519L11.4707 13.4634L9.33691 11.4058L7.28223 13.5396C6.96326 13.87 6.4363 13.8807 6.10547 13.562C5.7748 13.2431 5.76545 12.7162 6.08398 12.3853L8.13867 10.2515L6.00684 8.19678L5.94824 8.13428C5.67624 7.81247 5.68682 7.33112 5.98535 7.021C6.28433 6.71089 6.76594 6.68155 7.09766 6.94189L7.16113 6.99854L9.29395 9.05322L11.3496 6.92139L11.4121 6.86279Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_3957_4942">
        <rect
          width="20.8333"
          height="20"
          fill="white"
          transform="translate(0.583008)"
        />
      </clipPath>
    </defs>
  </svg>
);
